import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import MealDetail from "../pages/meal-detail/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/meal/:id",
    element: <MealDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
